import { render } from "./Clock.vue?vue&type=template&id=37c21dd4"
const script = {}
script.render = render

export default script